import React, { Component, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { bindActionCreators } from "redux";
import { withRouter } from 'react-router';
import cookie from "react-cookies";
import {
  getRiskQuestionAns,
  evaluateRiskAppetite,
  getBasketRecommendation,
  getRiskAppetitesList,
  cleanRiskContent,
  savePreLoginData,
  verifyOTP,
  resendOTP,
  encryptAES,
  decryptAES,
  encryptAESforKYC,
  cleanAuthContent,
} from "../../action";
import SecondaryNav from "../../../../general/SecondaryNav";
import Authentication from "../Common/Authentication";
import { closePopup, openPopup } from "../../../../general/Modal/action";
import { MODALS } from "../../../../general/Modal/constants";
import { ACTION, JOURNEYPAGE_TYPE } from "../../constants";
import NoContent from "../../../../general/NoContent";
import moment from "moment";
import ENV_CONFIG from '../../../../../../config/environment'
import "./style.scss";
import "../style.scss";

const RiskProfiler = (props) => {
  const {
    getRiskQuestionAns,
    evaluateRiskAppetite,
    getBasketRecommendation,
    getRiskAppetitesList,
    cleanRiskContent,
    investmentBasket,
    verifyOTP,
    savePreLoginData,
    resendOTP,
    closePopup,
    openPopup,
    location,
    history,
    switchToGoals,
    cleanAuthContent,
  } = props;
  const [journeyPage, setJourneyPage] = useState(0);
  const [questionNumber, setQuestionNumber] = useState(0);
  const [progress, setProgress] = useState(0);
  const [quesAnsDetail, setQuesAnsDetail] = useState([]);
  const [selectedOption, setSelectedOption] = useState(-1);
  const [answerArray, setAnswerArray] = useState([]);
  const [kycData, setKycData] = useState(null);
  const [uuid, setUuid] = useState(null);
  // const [readMore, setReadMore] = useState(false);
  const [authvalues, setAuthvalues] = useState({
    pan: "",
    dob: "",
    mobile: "",
    email: "",
  });
  const [OTP, setOtp] = useState();
  const [riskAppetite, setRiskAppetite] = useState("");
  const [basket, setBasket] = useState("");
  const [schemeList, setSchemeList] = useState(null);
  const [riskAppetiteValue, setRiskAppetiteValue] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [redirectionLink, setRedirectionLink] = useState(null);
  const [fromGoalJourney, setFromGoalJourney] = useState(false);
  const aboutJourney =
    "Your investing personality determines the type of investor you are. The investment personality profiler calculation considers many factors, including age, financial background, conditions and your investment aspirations.";

  const onLoad = async () => {
    let response = await getRiskQuestionAns();
    let queryParam = getQueryParams();
    if(queryParam && queryParam.journey && queryParam.journey === 'INVESTMENT_PERSONALITY') setFromGoalJourney(true);
    else setFromGoalJourney(false);
  };

  const onUnload = () => {
    cleanRiskContent();
  };

  const onEvaluateClick = () => {
    setJourneyPage(JOURNEYPAGE_TYPE.RISK_QUESTIONNAIRE);
  };

  const onClick = async () => {
    let response = await getRiskQuestionAns();
    response && setJourneyPage(JOURNEYPAGE_TYPE.RISK_LANDING);
  }

  const onNextClick = () => {
    setQuestionNumber((prev) => prev + 1);
    setSelectedOption(
      answerArray[questionNumber + 1]
        ? answerArray[questionNumber + 1].optionId
        : -1
    );
    setProgress((prog) => prog + 100 / quesAnsDetail.length);

    if (questionNumber === quesAnsDetail.length - 1) {
        const fetchRiskAppetite = async () => {
          let data = {
            queAndAns: answerArray,
          };
          await evaluateRiskAppetite(data);
        };
      fetchRiskAppetite();
      setQuestionNumber(0);
      setJourneyPage(JOURNEYPAGE_TYPE.RISK_AUTH);
    }
  };

  const onPrevClick = () => {
    setQuestionNumber((prev) => prev - 1);
    setProgress((prog) => prog - 100 / quesAnsDetail.length);
    setSelectedOption(answerArray[questionNumber - 1].optionId);
  };

  const onOptionClick = (questionId, optionId) => {
    setSelectedOption(optionId);
    setAnswerArray((prev) =>
      prev.map((answer) => {
        if (answer.questionId === questionId) {
          return {
            ...answer,
            optionId,
          };
        }
        return answer;
      })
    );
    investmentBasket.riskAppetite.apiLoaded && setDisabled(true);
  };

  const onOtpSubmit = (OTP) => {
    closePopup();
    setOtp(OTP);
    setJourneyPage(JOURNEYPAGE_TYPE.RISK_RECOMMENDATION);
}

  const onSubmit = (authValues, kycData) => {
    setAuthvalues((currentValue) => ({
      ...currentValue,
      pan: authValues.pan,
      dob: authValues.dob,
      mobile: authValues.mobile,
      email: authValues.email,
    }));
    if(kycData && kycData.data && kycData.data.kycVerifiedFlag){
      setKycData(kycData);
      let modalData = {
          closeAction: closePopup,
          modalClass: 'verify-otp-modal',
          maskedMobile: kycData && kycData.data && kycData.data.maskedMobile ? kycData.data.maskedMobile : '',
          maskedEmail: kycData && kycData.data && kycData.data.maskedEmail ? kycData.data.maskedEmail : '',
          onOtpSubmit,
          verifyOTP,
          resendOTP,
          secretLink: kycData && kycData.data && kycData.data.secretLink,
          dob: authValues.dob,
          pan: authValues.pan,
          journey: ACTION.JOURNEY.RISK_PROFILER,
          registrationType: kycData && kycData.data && kycData.data.registrationType,
          encrypt: encryptAES,
          decrypt: decryptAES,
      }
      openPopup(MODALS.VERIFY_OTP, modalData)
    } else if (kycData && kycData.data && kycData.data.registrationType == 'NEW' && kycData.data.kycStatus == 'NOT_VALIDATED'){
      let modalData={
          modalClass: 'ekyc-validate-modal',
          kycData: kycData.data,
          okAction: okAction,
          cleanAuthContent: cleanAuthContent,
      }
      openPopup(MODALS.EKYC_VALIDATE_MODAL, modalData)
    } else if (kycData && kycData.data && kycData.data.registrationType == 'NEW' && kycData.data.kycStatus == 'HOLD'){
      let modalData={
          modalClass: 'ekyc-validate-modal',
          kycData: kycData.data,
          okAction: okAction,
          cleanAuthContent: cleanAuthContent,
      }
      openPopup(MODALS.EKYC_VALIDATE_MODAL, modalData)
    }

    else setJourneyPage(JOURNEYPAGE_TYPE.RISK_KYC);
  };

  const onStepOneClick = () =>{
    setJourneyPage(JOURNEYPAGE_TYPE.RISK_QUESTIONNAIRE);
    setQuestionNumber(0);
    setProgress(100 / quesAnsDetail.length);
    setSelectedOption(answerArray[0].optionId);
    setAuthvalues((currentValue) => ({
      ...currentValue,
      pan: '',
      dob: '',
      mobile: '',
    }));
  }
  const onStepOneClickReset = () =>{
    setJourneyPage(JOURNEYPAGE_TYPE.RISK_LANDING);
    setQuestionNumber(0);
    setProgress(100 / quesAnsDetail.length);
    setSelectedOption(answerArray[0].optionId);
    setAuthvalues((currentValue) => ({
      ...currentValue,
      pan: '',
      dob: '',
      mobile: '',
    }));
    cleanAuthContent();
  }

  const onStepTwoClick = () =>{
    investmentBasket.riskQuestion.apiLoaded && !disabled && setJourneyPage(JOURNEYPAGE_TYPE.RISK_RECOMMENDATION);
  }

  const getQueryParams = () => {
    // this func will return an object whose keys represent query keys and value represemts value mapped with queries
    // {journey : "investmentPersonality"}
    var queryParam = location.search;
    queryParam = queryParam.slice(1);
    var queries = queryParam.split("&");
    var result = {};
    queries.forEach((ele) => {
      var key = ele.split("=")[0];
      var value = ele.split("=")[1];
      result[key] = value;
    });
    return result;
  };

  useEffect(() => {
    onLoad();
    return () => {
      onUnload();
    };
  }, []);
  useEffect(() => {
    if(authvalues.pan && authvalues.dob) {
        let object = {
            pan: authvalues.pan,
            dob: moment(authvalues.dob).format("DD-MMM-YYYY"),
            email: authvalues.email,
            mobile: authvalues.mobile,
        }
        setRedirectionLink(encryptAESforKYC(object));
    }
}, [authvalues]);

  useEffect(() => {
    if (investmentBasket.riskQuestion.apiLoaded) {
      var queryParam = getQueryParams();
      queryParam && queryParam.journey && queryParam.journey === 'INVESTMENT_PERSONALITY' && setJourneyPage(JOURNEYPAGE_TYPE.RISK_QUESTIONNAIRE);
      let scrollToElement = require('scroll-to-element');
        scrollToElement(document.querySelector(".invest-smart"), {
            ease: 'linear',
            duration: 100,
        });
      let quesAnsDetail =
        investmentBasket.riskQuestion.data.questionAndAnswerDetail
          .questionAndAnswers.sort((a, b) => {
            return a.sequence - b.sequence;
          });
      setQuesAnsDetail(quesAnsDetail);
      setProgress(100 / quesAnsDetail.length);
      let answerArray = quesAnsDetail.map((ele) => {
          return {
            questionId: ele.riskQuestionsDTO[0].questionId,
            optionId: -1,
          };
        });
      setAnswerArray(answerArray);
    }
  }, [investmentBasket.riskQuestion]);

  useEffect(() => {
    if(investmentBasket.riskAppetite.apiLoaded){
      setDisabled(false);
      let risk = investmentBasket.riskAppetite.data;
      setRiskAppetite(risk.riskAppetite ? risk.riskAppetite : 'MODERATE')
    }
  },[investmentBasket.riskAppetite])

  useEffect(() => {
    const fetchBasket = async () => {
      let data = {
        riskAppetite,
      };
      const response = await getBasketRecommendation(data);
      response && setBasket(response.data.basketName);

      let schemesInBasket = [];
      response && response.data.schemesInBasket && response.data.schemesInBasket.map((scheme)=>{
        schemesInBasket.push(scheme);
      })

      setSchemeList(schemesInBasket);
    };
    riskAppetite && fetchBasket();

    const fetchRiskAppetitesList = async () => {
      let data = {
        riskAppetite,
      };
      const response = await getRiskAppetitesList(data);
      const idx = response.data.allRiskAppetites.findIndex((val) => {
        return val.name === riskAppetite;
      });
      setRiskAppetiteValue(response.data.allRiskAppetites[idx].value);
    };
    riskAppetite && fetchRiskAppetitesList();
  }, [riskAppetite]);

  useEffect(() => {
        var queryParam = getQueryParams();
        if(riskAppetiteValue && queryParam && queryParam.journey){
            // window.location = `/goal-planning?goalId=${queryParam.goalId}&journey=GOAL_PLANNING&riskAppetite=${riskAppetiteValue.replace(" " , "_")}`;
            history.push(`/?goalId=${queryParam.goalId}&journey=GOAL_PLANNING&riskAppetite=${riskAppetiteValue.replace(" " , "_")}`);
            switchToGoals();
        }
  },[riskAppetiteValue])


  useEffect(() => {
     if(investmentBasket.otpVerificationData.apiLoaded && investmentBasket.otpVerificationData.data && investmentBasket.otpVerificationData.data.uuid){
       setUuid(investmentBasket.otpVerificationData.data.uuid);
       if(investmentBasket.riskQuestion && investmentBasket.riskQuestion.data){
             const saveDetails = async () => {
                     let params = {
                         panNumber: authvalues.pan,
                         journey: ACTION.JOURNEY.RISK_PROFILER,
                         step: 'FIRST',
                         basket:investmentBasket.basket && investmentBasket.basket.data ? true : false,
                         basketDetails: investmentBasket.basket && investmentBasket.basket.data ? investmentBasket.basket.data : null,
                         riskAppetite: investmentBasket.riskAppetite.data.riskAppetite,
                         riskQuesAndAnsSet: answerArray,
                         nriFlag : cookie.load("taxData"),
                     }
                     let response = await savePreLoginData(encryptAES(JSON.stringify(params)), investmentBasket.otpVerificationData.data.uuid);
             }
             saveDetails();
          }
     }
  },[investmentBasket.otpVerificationData]);

  const onBack = () => {
    onStepOneClick();
  }

  const okAction = () => {
    setJourneyPage(0);
  }

  return (
    <div className="investment-basket-journeys risk-profiler main-section clearfix">
      {investmentBasket.riskQuestion.apiLoaded ? <div className="content-section clearfix">
      {/* {journeyPage !=JOURNEYPAGE_TYPE.RISK_LANDING && <p className="description">{aboutJourney}</p>} */}

      {/* {(journeyPage === JOURNEYPAGE_TYPE.RISK_QUESTIONNAIRE || journeyPage === JOURNEYPAGE_TYPE.RISK_KYC || journeyPage === JOURNEYPAGE_TYPE.RISK_RECOMMENDATION) &&
        <ul className="steps">
          <li className={`step ${journeyPage === JOURNEYPAGE_TYPE.RISK_QUESTIONNAIRE && "activeStep"}`} onClick={onStepOneClick}>
            Questions
            <img className={`arrowIcon ${journeyPage === JOURNEYPAGE_TYPE.RISK_QUESTIONNAIRE && "activeArrow"}`} src='/images/investment-basket/goal-planning/Arrow.svg'/>
          </li>
          <li className={`step ${(journeyPage === JOURNEYPAGE_TYPE.RISK_RECOMMENDATION) && "activeStep"} ${disabled && 'disabled'}`} onClick={onStepTwoClick}>
          Investment Personality
            <img className={`arrowIcon ${(journeyPage === JOURNEYPAGE_TYPE.RISK_RECOMMENDATION) && "activeArrow"}`} src='/images/investment-basket/goal-planning/Arrow.svg'/>
          </li>
        </ul>
      } */}

        {journeyPage === JOURNEYPAGE_TYPE.RISK_LANDING && (
          <div className="risk-container">
            <p className="description">{aboutJourney}</p>
            <button className="evaluate-btn" onClick={onEvaluateClick}>
              Evaluate
            </button>
          </div>
        )}

        {journeyPage === JOURNEYPAGE_TYPE.RISK_QUESTIONNAIRE && (
          <div className="question-container">
            <div id="progress-bar">
              <div
                className="progress-done"
                style={{ width: `${progress}%` }}
              ></div>
              <div className="currentQues">
                {questionNumber + 1} of {quesAnsDetail.length}
              </div>
            </div>
            <div className="questionnaire">
                 <div className="questions">
                  {quesAnsDetail && quesAnsDetail[questionNumber] && quesAnsDetail[questionNumber].question}
                </div>            
                <div className="options">
                  {quesAnsDetail && quesAnsDetail[questionNumber] && quesAnsDetail[questionNumber].riskQuestionsDTO
                    .sort((a, b) => {
                      return a.optionId - b.optionId;
                    })
                    .map((option) => {
                      return (
                        <div
                          className="ques-option"
                          onClick={() =>
                            onOptionClick(option.questionId, option.optionId)
                          }
                          key={option.optionId}
                        >
                          <input
                            type="radio"
                            name="options"
                            id={option.optionId}
                            checked={
                              option.optionId === selectedOption ? true : false
                            }
                          />
                          {option.answer}
                        </div>
                      );
                    })}
                </div>
            </div>
            <div className="action-btn">
              {questionNumber>=1 && <button
                className={`prev-btn ${questionNumber === 0 && "disabled"}`}
                onClick={onPrevClick}
                disabled={questionNumber === 0}
              >
                Previous
              </button>}
              <button
                className={`next-btn ${selectedOption === -1 && "disabled"}`}
                onClick={onNextClick}
                disabled={selectedOption === -1}
              >
              {( questionNumber === quesAnsDetail.length - 1) ? 'Submit' : 'Next'}
              </button>
            </div>
          </div>
        )}

{!fromGoalJourney && journeyPage === JOURNEYPAGE_TYPE.RISK_AUTH && (
            <Authentication onSubmit={onSubmit} authValues={authvalues} onBack={onBack} journey={ACTION.JOURNEY.RISK_PROFILER} setJourneyPage={setJourneyPage} onClick={onClick}/>
        )}

        {journeyPage === JOURNEYPAGE_TYPE.RISK_RECOMMENDATION && (
            <div className="recommendation-container">
              <div className="aboutPersonality">
                <div className="investment-personality">
                  <h4>Your Investment Personality</h4>
                  <div className="riskometer">
                    <img src={`/images/investment-basket/risk-profile/${riskAppetiteValue}.svg`} alt="Riskometer icon"/>
                  </div>
                </div>
                <div className="recommendation">
                  <h4>Basket Recommendation</h4>
                  <div className="schemesInBasket">
                    <h1 className="basketType">{basket}</h1>
                    <div>
                      {schemeList.map((scheme)=>{
                        return <a href={`/product-solutions/overview/${scheme.linkUrl}/direct`}><h4 className="schemes">{scheme.schemeName}</h4></a>
                      })}
                    </div>
                  </div>
                </div>
              </div>
              <div className="startInvesting">
                    <a href={investmentBasket.otpVerificationData && investmentBasket.otpVerificationData.data && investmentBasket.otpVerificationData.data.uuid ? `${ENV_CONFIG.INVESTOR_BASE_URL}/invest-now?id=${investmentBasket.otpVerificationData.data.uuid}` : ''} target="_blank"
                    rel="noreferrer"
                    onClick={onStepOneClickReset}>
                    Start Investing
                    </a>
                </div>
            </div>
        )}
        {journeyPage === JOURNEYPAGE_TYPE.RISK_RECOMMENDATION && <div className='disclaimer'>
          <div className='disclaimer-head'>
              <span>Disclaimers:</span>
          </div>
          <div className='disclaimer-text'>
              <p className='disclaimer-text-top'>
              The information contained herein is to help you to plan and invest based on your risk profile in a diversified and convenient manner. The scheme recommended are only suggestions. Investors are free to choose other schemes and proportions for their investments. Investors may invest in different schemes by logging in separately. Investment in each scheme will be distinct and governed by the terms and conditions of that scheme.  For Complete details of the schemes including riskometer, product label, scheme related documents or to see other schemes offered by HDFC Mutual Fund, refer to the product pages <a href="/product-solutions">click here</a>.
              </p>
              {/* {readMore &&  */}
              <p className='disclaimer-text-bottom'>
              The returns mentioned as part of the questionnaire are purely theoretical in order to better understand your investment personality and is not an indication / guarantee of expected returns from investing into any of our Mutual Fund offerings. Investors are requested to note that the above investment suggestions should not be construed as financial planning / investment advice by HDFC Mutual Fund/ HDFC AMC. The above suggestions do not in any manner, indicate or imply either the quality of any particular Scheme or guarantee any specific performance/returns. It does not have regard to specific investment objectives, financial situation and the particular needs of any specific person. The information/ data herein alone is not sufficient and should not be used for the development or implementation of an investment strategy. Neither HDFC AMC and HDFC Mutual Fund nor any person connected with them, accepts any liability arising from the use of information herein. Investor before acting on any information herein should make his/her/their own investigation and seek appropriate professional advice and shall alone be fully responsible / liable for any decision taken on the basis of information contained herein. 
              </p>
              {/* } */}
              {/* <a onClick={() => setReadMore(!readMore)} className="read-more">{readMore ? 'Read Less' : 'Read More'}</a> */}
          </div>
        </div>}
        {journeyPage === JOURNEYPAGE_TYPE.RISK_KYC && (
          <div className="not-kyc-verified">
            <p className="kycPage-title">WELCOME TO HDFC MF FAMILY!</p>
            <p>Kindly complete your KYC to start your investment journey</p>
            <a
              href={`${ENV_CONFIG.INVESTOR_BASE_URL}/ekyc?prefill=${redirectionLink}`}
              target="_blank"
              rel="noreferrer"
              className="complete-kyc"
            >
              COMPLETE KYC
            </a>
          </div>
        )}
      </div> : <NoContent />}
    </div>
  );
};

const mapStateToProps = (state) => ({
  commonContent: state.commonContent,
  investmentBasket: state.homePage,
});

const mapDispatchToProps = (dispatch) => ({
  getRiskQuestionAns: bindActionCreators(getRiskQuestionAns, dispatch),
  evaluateRiskAppetite: bindActionCreators(evaluateRiskAppetite, dispatch),
  getBasketRecommendation: bindActionCreators(getBasketRecommendation,dispatch),
  getRiskAppetitesList: bindActionCreators(getRiskAppetitesList, dispatch),
  cleanRiskContent: bindActionCreators(cleanRiskContent, dispatch),
  savePreLoginData: bindActionCreators(savePreLoginData, dispatch),
  verifyOTP: bindActionCreators(verifyOTP, dispatch),
  resendOTP: bindActionCreators(resendOTP, dispatch),
  closePopup: bindActionCreators(closePopup, dispatch),
  openPopup: bindActionCreators(openPopup, dispatch),
  cleanAuthContent: bindActionCreators(cleanAuthContent, dispatch),
});

const RiskProfilerContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(RiskProfiler);

export default withRouter(RiskProfilerContainer);
